<script>
import { layoutMethods, smsBlastCampaignMethods} from "@/state/helpers";
// import { campaignData } from "./mock_data_view_campaign";
import feather from 'feather-icons';

// import moment from 'moment-timezone';
// import "flatpickr/dist/flatpickr.css";

export default {
  page: {
    title: "SMS Campaign Details",
  },
  data() {
    return {
      campaign: {
        id: 0,
        campaignName: "",
        scheduledDate: "",
        senderName: "",
        message: "",
        mobileNumbers: [],
        pageInfo: {
          total: 0,
          noOfPage: 0,
          currentPage: 0,
          nextPage: 0,
          prevPage: 0,
          range: 0
        },
        totalRecipient: 0,
        sent: 0,
        failed: 0,
        status: ""
      },
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50],
      searchMobileNumber: "",
      orderBy: "id",
      sortDesc: false,
      search: {
        keyword: "",
        field: "",
        status: "",
        dateRange: null,
        filter: "",
        filterKeyword: "",
      },
      filterStatus: "all",
      filterStatusOption: [
        { text: "All", value: "all" },
        { text: "Sent", value: "sent" },
        { text: "Failed", value: "failed" },
      ],
      fields: [
        { key: 'number', label: 'Mobile Number', sortable: false },
        { key: 'status', label: 'Status', sortable: false }
      ],
      debounceSearch: null,
      isSearching: false,
      searchPending: false,
      autoRefreshTimer: null,
      isAutoRefreshEnabled: true,
      lastAutoRefresh: null,
    };
  },
  components: {
    // flatPickr,
  },
  filters: {
    timeAgo(value) {
      if (!value) return '';
      const now = new Date();
      const diff = Math.floor((now - value) / 1000); // seconds
      
      if (diff < 60) return `${diff}s ago`;
      if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
      if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
      return `${Math.floor(diff / 86400)}d ago`;
    }
  },
  computed: {
    totalMobileNumbers() {
      return this.campaign.mobileNumbers ? this.campaign.mobileNumbers.length : 0;
    },
    // filteredMobileNumbers() {
    //   if (!this.campaign.mobileNumbers) return [];
      
    //   let filtered = this.campaign.mobileNumbers;
      
    //   // Filter by search term
    //   if (this.searchMobileNumber.trim()) {
    //     filtered = filtered.filter(item => 
    //       item.number && item.number.toLowerCase().includes(this.searchMobileNumber.toLowerCase())
    //     );
    //   }
      
    //   // Filter by status
    //   if (this.filterStatus !== 'all') {
    //     filtered = filtered.filter(item => 
    //       item.status && item.status.toLowerCase() === this.filterStatus.toLowerCase()
    //     );
    //   }
      
    //   return filtered;
    // }
  },
  watch: {
    filterStatus: {
      handler() {
        this.onStatusFilterChange();
      }
    }
  },
  methods: {
    ...layoutMethods,
    ...smsBlastCampaignMethods,
    sortList(action) {
      this.orderBy = action.sortBy;
      this.sortDesc = action.sortDesc;
    },
    async fetchSMSCampaignDetails(id, isAutoRefresh = false) {
      if (id > 0) {
        await this.actionSMSBlastAPIPOST({
          params: { 
              id: id,  
              page: this.currentPage,
              rows: this.perPage,
              sort: this.sort,
              orderBy: this.orderBy,
              search: this.search,
          },
          action: 'details',
          hidePreloader: isAutoRefresh // Hide preloader for auto-refresh calls
        }).then((res) => {
          const { status, message} = res;
          // console.log(`SMS Campaign Details (${isAutoRefresh ? 'Auto-refresh' : 'Manual fetch'}):`, res);
          if(status == 'ok')
          {
            this.campaign.id = message.id;
            this.campaign.campaignName = message.campaignName || "";
            this.campaign.scheduledDate = message.scheduledDate;
            this.campaign.senderName = message.senderName || "";
            this.campaign.message = message.message || "";
            this.campaign.mobileNumbers = message.recipients?.rows && message.recipients?.rows.length > 0 ? message.recipients.rows : [""];
            this.campaign.pageInfo = message.recipients?.pageInfo || {};
            this.campaign.totalRecipient = message.totalRecipient || 0;
            this.campaign.sent = message.sent || 0;
            this.campaign.failed = message.failed || 0;
            this.campaign.status = message.status;
            
            if(isAutoRefresh) {
              this.lastAutoRefresh = new Date();
              // Replace feather icons after auto-refresh updates
              this.$nextTick(() => {
                feather.replace({ width: 18, height: 18 });
              });
            }
          }
        }).catch((error) => {
          console.error('Failed to fetch campaign details:', error);
          // On error, we might want to disable auto-refresh temporarily
          if(isAutoRefresh) {
            console.warn('Auto-refresh failed, continuing...');
          }
        });
      }
    },
    async onMobileNumberPageUpdate() {
      await this.fetchSMSCampaignDetails(this.$route.params.id);
    },
    async onDisplayChange() {
      this.currentPage = 1;
      await this.fetchSMSCampaignDetails(this.$route.params.id);
    },
    async onStatusFilterChange() {
      // Update status filter in the search object
      this.search.filter = this.filterStatus === 'all' ? '' : this.filterStatus;
      this.currentPage = 1; // Reset to first page when filtering
      await this.fetchSMSCampaignDetails(this.$route.params.id);
    },
    async onExport() {
      await this.actionSMSBlastAPIPOST({
        params: {
          id: this.$route.params.id,
          page: this.currentPage,
          rows: this.perPage,
          sort: this.sort,
          orderBy: this.orderBy,
          search: this.search,
          email: JSON.parse(localStorage.getItem('userData')).email
        },
        action: 'export-recipients',
      }).then((res) => {
        const { status, message } = res;
        if(status == 'ok') {
          // Trigger file download
          console.log(message);
        } else {
          console.error('Export failed or no file URL provided:', message);
        }
      }).catch((error) => {
        console.error('Failed to export recipients:', error);
      });
    },
    onSearchInput() {
      // Clear existing timeout
      if (this.debounceSearch) {
        clearTimeout(this.debounceSearch);
      }
      
      // Show pending state if there's text
      this.searchPending = this.searchMobileNumber.trim().length > 0;
      
      this.debounceSearch = setTimeout(() => {
        this.performSearch();
      }, 2000); // 2 seconds delay
    },
    onSearchEnter() {
      // Clear any pending timeout
      if (this.debounceSearch) {
        clearTimeout(this.debounceSearch);
      }
      this.searchPending = false;
      this.performSearch();
    },
    async performSearch() {
      try {
        this.isSearching = true;
        this.searchPending = false; // Clear pending state
        // Update search in the search object
        this.search.keyword = this.searchMobileNumber;
        this.search.field = 'phone_number';
        this.currentPage = 1; // Reset to first page when searching
        await this.fetchSMSCampaignDetails(this.$route.params.id);
      } catch (error) {
        console.error('Search failed:', error);
      } finally {
        this.isSearching = false;
      }
    },
    startAutoRefresh() {
      // Clear any existing timer first
      this.stopAutoRefresh();
      
      if (this.isAutoRefreshEnabled && this.$route.params.id > 0) {
        this.autoRefreshTimer = setInterval(async () => {
          try {
            // Only auto-refresh if the campaign is still processing or pending
            if (['Processing', 'Pending'].includes(this.campaign.status)) {
              await this.fetchSMSCampaignDetails(this.$route.params.id, true);
            } else if (this.campaign.status === 'Sent' || this.campaign.status === 'Failed') {
              // Stop auto-refresh for completed campaigns
              // console.log('Campaign completed, stopping auto-refresh');
              this.stopAutoRefresh();
            }
          } catch (error) {
            console.error('Auto-refresh error:', error);
          }
        }, 3000); // 3 seconds interval
        
        // console.log('Auto-refresh started (3s interval)');
      }
    },
    stopAutoRefresh() {
      if (this.autoRefreshTimer) {
        clearInterval(this.autoRefreshTimer);
        this.autoRefreshTimer = null;
        // console.log('Auto-refresh stopped');
      }
    },
    toggleAutoRefresh() {
      this.isAutoRefreshEnabled = !this.isAutoRefreshEnabled;
      if (this.isAutoRefreshEnabled) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
      // Replace feather icons after toggle
      this.$nextTick(() => {
        feather.replace({ width: 18, height: 18 });
      });
    },
  },
  async mounted() {
    
    this.changeTitle({ title: "SMS Campaign Details" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Notification", to: { name: "" } },
        { text: "SMS Blast", to: { name: "SMS Blast Campaign" } },
        { text: "SMS Campaign Details", to: { name: "" } },
      ],
    });

    if (this.$route.params.id > 0) {
      await this.fetchSMSCampaignDetails(this.$route.params.id);
      // Start auto-refresh after initial load
      this.startAutoRefresh();
    }

    // Replace feather icons initially and after any updates
    this.$nextTick(() => {
      feather.replace({ width: 18, height: 18 });
    });
  },
  beforeDestroy() {
    // Clear any pending timeouts
    if (this.debounceSearch) {
      clearTimeout(this.debounceSearch);
    }
    // Stop auto-refresh timer
    this.stopAutoRefresh();
    // Reset states
    this.isSearching = false;
    this.searchPending = false;
  },
};
</script>
<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h3>SMS Campaign</h3>
            
            <div class="row mb-4">
              <div class="col-12">
                <div class="mb-3">
                  <div class="fs-5 mb-1">Campaign Name: <span class="fw-normal">{{ campaign.campaignName }}</span></div>
                </div>
                
                <div class="mb-3">
                  <div class="fs-5 mb-1">Schedule Date: <span class="fw-normal">{{ campaign.scheduledDate | customFormatDate }}</span></div>
                </div>
                
                <div class="mb-3">
                  <div class="fs-5 mb-1">Sender Name: <span class="fw-normal">{{ campaign.senderName }}</span></div>
                </div>
                
                <div class="mb-3">
                  <div class="fs-5 mb-1">Status: 
                    <span class="fw-normal" :class="{
                      'text-brand-blue': campaign.status === 'Processing',
                      'text-success': campaign.status === 'Sent',
                      'text-danger': campaign.status === 'Failed',
                      'text-warning': campaign.status === 'Pending'
                    }">{{ campaign.status }}</span>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="fs-5 mb-1">Total Mobile Number: <span class="fw-normal">{{ campaign.totalRecipient.toLocaleString() }}</span></div>
                </div>
                
                <div class="mb-3">
                  <div class="fs-5 mb-1">Success Sent: <span class="fw-normal">{{ campaign.sent > 0 ? campaign.sent.toLocaleString() : '--' }}</span></div>
                </div>
                
                <div class="mb-3">
                  <div class="fs-5 mb-1">Failed Sent: <span class="fw-normal">{{ campaign.failed > 0 ? campaign.failed.toLocaleString() : '--' }}</span></div>
                </div>

                <button 
                  v-if="['Failed', 'Sent'].includes(campaign.status)"
                  type="button" 
                  class="btn btn-primary me-2"
                  @click="onExport"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="10" height="12" viewBox="0 0 10 12" fill="none">
                    <path d="M9.66732 4H7.00065V0H3.00065V4H0.333984L5.00065 8.66667L9.66732 4ZM0.333984 10V11.3333H9.66732V10H0.333984Z" fill="white"/>
                  </svg>
                  Download Recipients
                </button>
              </div>
            </div>

            <div class="mb-4">
              <label class="form-label" style="width: 100px">Message</label>
              <b-form-textarea
                v-model="campaign.message"
                rows="4"
                readonly
                style="resize: none; background-color: #f8f9fa"
              ></b-form-textarea>
            </div>            <div class="mb-4">
              
              
              <!-- Search and Filter -->
              <div class="row mb-3">
                <div class="col-6">
                  <h5>Send SMS Blast</h5>
                </div>
                <div class="col-6 d-flex justify-content-end gap-3">
                  <div class="search-box" style="width: 300px;">
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control rounded"
                        :class="{ 
                          'border-secondary': searchPending,
                          'border-secondary': isSearching
                        }"
                        placeholder="Search Mobile Number"
                        v-model="searchMobileNumber"
                        @input="onSearchInput"
                        @keyup.enter="onSearchEnter"
                        :disabled="isSearching"
                      >
                      <!-- Show different icons based on state -->
                      <i v-if="isSearching" class="spinner-border spinner-border-sm search-icon text-secondary" role="status"></i>
                      <i v-else-if="searchPending" data-feather="clock" class="search-icon text-secondary"></i>
                      <i v-else data-feather="search" class="search-icon"></i>
                    </div>
                    <!-- Status text -->
                    <small v-if="searchPending" class="text-secondary">Press 'Enter' to search now.</small>
                    <small v-else-if="isSearching" class="text-secondary">Searching...</small>
                  </div>
                  <div class="filter-status" style="width: 200px;">
                    <select class="form-select mb-1" v-model="filterStatus">
                      <option v-for="option in filterStatusOption" :key="option.value" :value="option.value">
                        {{ option.text }}
                      </option>
                    </select>
                    <span class="fs-6 text-muted">Filter by status</span>
                  </div>
                </div>
              </div>

              <!-- Mobile Numbers Table -->
              <div class="mobile-numbers-container">
                <div class="table-responsive">
                  <div class="table align-middle table-nowrap">
                    <b-table
                      :items="campaign.mobileNumbers"
                      :fields="fields"
                      responsive="sm"
                      :sort-by.sync="orderBy"
                      :sort-desc.sync="sortDesc"
                      class="table-check"
                      @sort-changed="sortList"
                      tbody-tr-class="align-middle"
                    >
                      <template #cell(status)="data">
                        <div
                          :class="{
                            'text-muted': data.item.status == '--',
                            'text-success': data.item.status == 'Sent',
                            'text-danger': data.item.status == 'Failed'
                          }"
                        >
                          {{ data.item.status }}
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div> 

              <!-- Pagination -->
              <div class="row mt-3">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col">
                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label">Display:</label>
                        <div class="col-sm-6">
                          <b-form-select
                            class="form-select shadow-none w-fit"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="float-end">
                        <b-pagination
                          v-model="currentPage"
                          @input="onMobileNumberPageUpdate()"
                          :total-rows="campaign.pageInfo.total || campaign.totalRecipient"
                          :per-page="perPage"
                          class="pagination-rounded"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
               <div class="d-flex justify-content-end align-items-center mt-4">
                  <div>
                    <button 
                      type="button" 
                      class="btn btn-lightgray me-2"
                      @click="$router.go(-1)"
                    >
                      Cancel
                    </button>
                    
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.card {
  border-radius: 8px;
}

.search-box {
  position: relative;
}

.search-box .form-control {
  padding-right: 40px;
}

.mobile-numbers-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 15px;
  background-color: #fff;
}

.search-box .search-icon {
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.filter-status {
  display: flex;
  flex-direction: column;
}

.filter-status .fs-6 {
  font-size: 12px !important;
  color: #6c757d;
}

.fs-5 {
  font-size: 1rem !important;
  font-weight: 500;
  color: #000;
}

.fw-normal {
  font-weight: 400 !important;
  color: #495057;
}

/* Table styling */
.table-responsive {
  margin: 0;
}

.table > :not(:first-child) {
  border-top: none;
}

.table > tbody > tr > td {
  padding: 1rem 0.75rem;
  vertical-align: middle;
  border-color: #eff2f7;
  color: #495057;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px;
  border: none;
  min-width: 32px;
  text-align: center;
}

/* Status colors */
.text-warning {
  color: #f1b44c !important;
}

.text-success {
  color: #34c38f !important;
}

.text-danger {
  color: #f46a6a !important;
}
</style>
